import types from './mutations-types';
import { ActionContext, ActionTree } from 'vuex';
import { VersionItem, RootStateShape, VersionsStateShape } from 'store';
import { Container } from '@/lib/classes/dependency-injector';
import { IVersionsServices } from 'services';

export default {
    async getVersions({ commit }: ActionContext<VersionsStateShape, RootStateShape>) {
        const versionsService = <IVersionsServices>Container.get('versions-service');
        const versions = await versionsService.getVersions();
        const latestVersion = versionsService.getLatest();

        if (versions) {
            commit(types.SET_VERSIONS, versions);
        }

        if (latestVersion) {
            commit(types.SET_CURRENT_VERSION, latestVersion.id);
        }
    },

    setVersion({ state, commit }: ActionContext<VersionsStateShape, RootStateShape>, newVersion: VersionItem) {
        if (state.versions[newVersion.id]) {
            commit(types.SET_CURRENT_VERSION, newVersion.id);
        } else {
            return new Error('Version doesnt exist');
        }
    }
} as ActionTree<VersionsStateShape, RootStateShape>;
